import { cn } from "@/lib/utils";

/** The pop.in wordmark — gradient "pop" + muted ".in". */
export function PopinMark({
  size = 28,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center font-extrabold leading-none tracking-[-.04em]",
        className,
      )}
      style={{ fontSize: size }}
    >
      <span className="text-brand-gradient">pop</span>
      <span className="text-text-3">.in</span>
    </span>
  );
}
